import { PARTNER } from "@tm/isomorphic-utils";
import { deviceType } from "@tm/static/utils";
import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { H2TagStyle } from "../TextStyles/TextStyles.style";

type styleProps = {
  disable?: boolean;
  singleItem?: boolean;
};
type styleOffersProps = {
  bgColor?: string;
  padding?: string;
};

export const ExclusiveOffersStyle = styled.div<styleOffersProps>`
  padding: 16px 0;
  width: 100%;
  background: ${(p) =>
    p.theme.pageTheme === PARTNER.MYBIZ ? `none` : theme.whiteText};
  position: relative;
  z-index: 1;
  overflow: hidden;
  display: flex;
  ${H2TagStyle} {
    width: 64%;
  }
  @media ${deviceType.mobile} {
    background: ${(p) => p.bgColor || theme.whiteText};
    padding: ${(p) => p.padding || "0 16px"};
  }
`;

export const OfferItemStyle = styled.a<styleProps>`
  display: inline-block;
  background-color: ${theme.whiteText};
  border-radius: 8px;
  width: 450px;
  height: 220px;
  flex-shrink: 0;
  overflow: hidden;
  @media ${deviceType.mobile} {
    width: 286px;
    height: 180px;
    border-radius: 16px;
    ${(p) =>
      p.singleItem &&
      `
      width: calc(100vw - 32px);
      height: calc((100vw - 32px) / 1.5888888888888888);
    `}
  }
`;

export const OffersWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  overflow-x: auto;
  margin-left: -16px;
  padding-left: 16px;
  margin-right: -16px;
  padding-right: 16px;
`;

export const SliderWrap = styled.div`
  display: flex;
  padding-left: 7px;
  padding-top: 7px;
`;

export const SlidesBtnWrap = styled.div`
  box-shadow: 0px 1px 7px 0px #00000033;
  background-color: ${theme.whiteText};
  border-radius: 100px;
  padding: 4px 14px;
  width: 72px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SliderArrowLeft = styled.span<styleProps>`
  border: solid ${theme.blueText};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  cursor: pointer;
  ${(p) => p.disable && `opacity: 0.5;`}
`;

export const SliderArrowRight = styled.span<styleProps>`
  border: solid ${theme.blueText};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  cursor: pointer;
  ${(p) => p.disable && `opacity: 0.5;`}
`;

export const SliderContainer = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;
`;
